module.exports = __webpack_public_path__ + "static/media/germany.d810f621.svg";